import { render, staticRenderFns } from "./CapacityDetails.vue?vue&type=template&id=33301798&"
import script from "./CapacityDetails.vue?vue&type=script&lang=js&"
export * from "./CapacityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports